export const salesforceSelectedObjectsContent = `
#### Review Your Objects

We'll automatically show you all your Salesforce objects:
- **Standard objects** like Account, Lead, Contact
- **Custom objects** your team created

Review the pre-selected list, then add or remove objects as needed.
These become live data models that update automatically, and you can adjust them later.
`;
